import React from 'react';
import Footer from '../components/Footer';
import { useImages } from '../context/ImageContext';

const MedicalAlertGlossaryPage: React.FC = () => {
  console.log('MedicalAlertGlossaryPage: Component rendering');
  
  const { getImage } = useImages();
  console.log('MedicalAlertGlossaryPage: useImages hook loaded');
  
  const heroImage = getImage('4-PR-alert1-1-3-.-alert1-medical-alert-system-2-.jpg');
  console.log('MedicalAlertGlossaryPage: Hero image URL:', heroImage);

  const glossaryTerms = [
    {
      term: 'A1AP',
      definition: `Alert1 Advantage Plan is a warranty plan in case of damage to your medical alert system.`
    },
    {
      term: 'AARP',
      definition: `Senior focused interest group that offers discounts. Alert1 offers a $1/month AARP discount.`
    },
    {
      term: 'Aging in place',
      definition: `Aging in place describes a person living in the residence of their choice, for as long as they are able.`
    },
    {
      term: 'Back-Up Battery',
      definition: `Alert1 medical alert systems come with an integrated battery system that automatically insures that the medical alert base station will continue to operate normally for up to 24 hours during a power failure.`
    },
    {
      term: 'Back-Up Power Supply',
      definition: `An integrated battery system that automatically insures the medical alert base station will continue to operate normally for up to 24 hours during a power failure.`
    },
    {
      term: 'Base Unit',
      definition: `Alert1's home medical alert systems use a base station that plugs into the wall and provides a coverage range of 600 ft. During an emergency, the Alert1 Command Center will speak through the base unit's two-way speaker and microphone.`
    },
    {
      term: 'Battery Testing',
      definition: `The medical alert base station monitors the power level of the battery and the emergency help button. The device automatically notifies Alert1 when the battery needs to be replaced. When we receive the notification that the emergency help button battery is low, we send a replacement emergency button at no additional cost.`
    },
    {
      term: 'BBB',
      definition: `Better Business Bureau. Alert1 is a BBB Accredited Business with an A+ rating.`
    },
    {
      term: 'Bill Payer',
      definition: `Individual who is paying for someone to use Alert1's medical alert monitoring system.`
    },
    {
      term: 'CAPS',
      definition: `Certified Aging in Place Specialist.`
    },
    {
      term: 'CARE',
      definition: `Compassion Answer Respect Evaluate. An acronym to help guide individuals when talking to senior loved ones about getting a medical alert.`
    },
    {
      term: 'Caregiver',
      definition: `A family member or paid helper who regularly looks after a child or a sick, elderly, or disabled person.`
    },
    {
      term: 'Circle of Care',
      definition: `The group of people we setup to contact when you press the emergency help button on your medical alert system.`
    },
    {
      term: 'Command Center',
      definition: `Where help button calls are directed. The operator assesses the situation and contacts emergency services or a loved one. Command Center operators are available 24 hours a day, 365 days a year.`,
      synonyms: `Emergency Monitoring Center, Monitoring Center, Central Station.`
    },
    {
      term: 'Coverage Area',
      definition: `The area where the medical alert system works. Alert1 coverage area is nationwide.`
    },
    {
      term: 'TMA 5 Diamond Certified',
      definition: `The Monitoring Association. Alert1's Command Center operators go through a rigorous emergency care training program to become TMA 5 Diamond Certified.`
    },
    {
      term: 'DSL',
      definition: `Digital Subscriber Line method of connecting to the internet. Our home based systems do work with DSL, although you may need an adapter.`
    },
    {
      term: 'Emergency Help Button',
      definition: `A waterproof emergency button, usually worn as a pendant or wristband. Pressing the button places a call to our emergency response center.`,
      synonyms: `duress button, elderly help button, emergency call button, medical alert button, medical panic button, senior help button, medical alert pendant`
    },
    {
      term: 'Emergency Responders',
      definition: `Ambulance, fire or police services within a local community. Emergency responders are dispatched by the Alert1 Monitoring Center if the member does not respond to the emergency operator.`,
      synonyms: `Paramedics, 911, EMS, First Aid and First Alert Responders.`
    },
    {
      term: 'Emergency Response Protocol',
      definition: `Your tailored plan for what happens when you push the button on your medical alert system.`
    },
    {
      term: 'EMS',
      definition: `Emergency medical services.`
    },
    {
      term: 'Fall Detection',
      definition: `Fall detection is a feature built into medical alert pendants that will sense the movement of a fall and automatically call for help. Fall detection is available in Alert1 home pendants or mobile pendants.`
    },
    {
      term: 'FFL',
      definition: `Friends For Life. Referral program. If you refer a friend to Alert1, each of you will get one month of free service.`
    },
    {
      term: 'GPS',
      definition: `GPS (global position system) is a satellite-based navigation system that is built into the PAX mobile fall detection pendant. Once a fall is sensed or the help button is pushed, the pendant activates the GPS to find the user's location.`
    },
    {
      term: 'Heat detectors',
      definition: `The heat detector that triggers a 95-decibel siren when the room temperature rises too quickly.`
    },
    {
      term: 'Home Care',
      definition: `Home care is non-medical supportive care provided in the home.`
    },
    {
      term: 'Installation',
      definition: `Process of setting up a medical alert system.`
    },
    {
      term: 'Kelsi',
      definition: `Mobile medical alert system.`
    },
    {
      term: 'Landline',
      definition: `Alert1's home medical alert system can connect to your telephone landline if you prefer. Wireless home medical alert systems are also available.`
    },
    {
      term: 'Life Alert',
      definition: `Company in the medical alarm industry based in Encino, CA.`
    },
    {
      term: 'Lockbox',
      definition: `A secure area for storing a key in case emergency and 911 personnel need to enter your home.`
    },
    {
      term: 'Medical Alert System',
      definition: `A communication device that allows you to call for help in the event you can't reach a phone. Most medical alert systems are activated when the subscriber presses his or her emergency help button. When the help button is pressed, a call is placed to a medical alert monitoring center. The operator then assesses the situation and contacts emergency services, or a loved one.`,
      synonyms: `home medical alert, medical alarm, medical alarm system, personal emergency response system, personal alert systems, PERS`
    },
    {
      term: 'Medical ID Bracelet',
      definition: `A bracelet that lists your medical conditions, drug and food allergies. Medical ID bracelets allow emergency responders to treat you quickly and effectively.`
    },
    {
      term: 'Member',
      definition: `Individual who is using Alert1's medical alert monitoring system and is part of the Alert1 family.`
    },
    {
      term: 'Monitoring Center',
      definition: `Where help button calls are directed. The operator assesses the situation and contacts emergency services, or a loved one. Command center operators are available 24 hours a day, 365 days a year.`,
      synonyms: `Emergency Monitoring Center, Command Center`
    },
    {
      term: 'PAX',
      definition: `Alert1's Mobile Fall Detection device.`
    },
    {
      term: 'PAX Plus',
      definition: `Alert1's Mobile + Home Fall Detection System.`
    },
    {
      term: 'PCI',
      definition: `Payment Card Industry Data Security Standard (PCI DSS) is a proprietary information security standard for organizations that handle credit cards. Alert1 is PCI compliant to keep our member's information safe.`
    },
    {
      term: 'PERS',
      definition: `Personal Emergency Response System`
    },
    {
      term: 'POM',
      definition: `Peace of Mind – State of being and the acronym behind our POM landline hardware.`
    },
    {
      term: 'Range',
      definition: `Safety zone or distance away from the base unit`
    },
    {
      term: 'Remote Call Answering',
      definition: `This feature of the POM home system allows you to answer incoming phone calls by pressing your emergency help button. Simply press the help button to answer on the third ring.`
    },
    {
      term: 'Responders',
      definition: `Individuals the subscriber has identified for the Command Center to contact in the event of an emergency. In most cases responders are friends, family members or neighbors who are close by and can respond to an emergency.`,
      synonyms: `Circle of Care, Emergency Contacts`
    },
    {
      term: 'Smart jewelry',
      definition: `A range of wearable devices, typically for women, that connect to the wearer's smartphone. The smart jewelry is designed to notify or alert the wearer.`
    },
    {
      term: 'Subscriber',
      definition: `Individual who is using Alert1's medical alert monitoring system.`
    },
    {
      term: 'Thayer Certification',
      definition: `Thayer Certified is the first 3rd party certification system to specifically target what consumers care about most: that human beings are not harmed or exploited in the provision of their products and services. Alert1 is Thayer Certified.`
    },
    {
      term: 'Two-Way Voice',
      definition: `Technology that uses both a microphone and a speaker, allowing emergency monitoring personnel to communicate with the subscriber in case of an emergency.`
    },
    {
      term: 'UL Listed',
      definition: `UL or Underwriters Laboratory, a safety certification standard. All Alert1 devices are UL compliant.`
    },
    {
      term: 'UTDOA',
      definition: `Uplink-Time Difference of Arrival is a wireless location technology that relies on cell tower triangulation. Alert1's mobile units use UTDOA to locate members when they press their button for help.`
    },
    {
      term: 'Voice Extender',
      definition: `An additional two-way speaker that can be placed in remote areas of your home to further amplify the speaker on the medical alert base station.`
    },
    {
      term: 'VOIP',
      definition: `Alert1 does not use VOIP (Voice over Internet Protocol). Internet connections can be unreliable as it cuts in and out. We use stand-alone wireless systems that do not rely on the internet.`
    },
    {
      term: 'Wall-Mounted Emergency Button',
      definition: `Emergency help button that can be mounted in areas of the home where falls are likely to occur. Common locations include the bathroom, next to the bed, or near stairs. Wall-mounted emergency buttons attach quickly with Velcro and are wireless.`
    }
  ];

  console.log('MedicalAlertGlossaryPage: Glossary terms loaded, count:', glossaryTerms.length);
  console.log('MedicalAlertGlossaryPage: First term:', glossaryTerms[0]);
  console.log('MedicalAlertGlossaryPage: Last term:', glossaryTerms[glossaryTerms.length - 1]);

  return (
    <div className="medical-alert-glossary-page">
      {/* Main Content Section */}
      <section style={{ padding: '2rem 1.5rem', background: 'white' }}>
        <div className="container" style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <div style={{ overflow: 'hidden' }}>
            <h1 style={{ 
              fontSize: '2.5rem', 
              fontWeight: 'bold', 
              marginBottom: '1.5rem', 
              color: '#c8102e',
              textAlign: 'left'
            }}>
              Glossary—Alert1 Medical Alert Service
            </h1>
            
            {/* Product Image - Float Left with Text Wrap */}
            {heroImage && (
              <img 
                src={heroImage} 
                alt="Alert1 Medical Alert System" 
                style={{ 
                  maxWidth: '250px',
                  width: '100%',
                  height: 'auto',
                  float: 'left',
                  marginRight: '1.5rem',
                  marginBottom: '1rem'
                }}
              />
            )}
            
            <p style={{ 
              fontSize: '1.1rem', 
              lineHeight: '1.6', 
              color: '#444',
              marginBottom: '2rem'
            }}>
              Medical alarm terminology can be difficult to follow. Here, we provide a list of commonly used words you may find useful when searching for medical alert devices.
            </p>
          </div>
          
          {/* Glossary Terms */}
          <div style={{ marginTop: '2rem' }}>
            {glossaryTerms.length === 0 && (
              <div style={{ padding: '2rem', background: '#ffe6e6', border: '2px solid red' }}>
                <h3>ERROR: No glossary terms found!</h3>
                <p>The glossaryTerms array is empty.</p>
              </div>
            )}
            {glossaryTerms.map((item, index) => {
              if (index === 0) {
                console.log('MedicalAlertGlossaryPage: Rendering first term:', item);
              }
              return (
              <div 
                key={index}
                style={{ 
                  marginBottom: '1.5rem',
                  paddingBottom: '1.5rem',
                  borderBottom: index < glossaryTerms.length - 1 ? '1px solid #e0e0e0' : 'none'
                }}
              >
                <h3 style={{ 
                  fontSize: '1.3rem', 
                  fontWeight: 'bold', 
                  marginBottom: '0.5rem', 
                  color: '#1a4d7a'
                }}>
                  {item.term}
                </h3>
                <p style={{ 
                  fontSize: '1rem', 
                  lineHeight: '1.6', 
                  color: '#444',
                  marginBottom: item.synonyms ? '0.5rem' : '0'
                }}>
                  {item.definition}
                </p>
                {item.synonyms && (
                  <p style={{ 
                    fontSize: '0.95rem', 
                    lineHeight: '1.6', 
                    color: '#666',
                    fontStyle: 'italic',
                    marginBottom: '0'
                  }}>
                    Synonyms: {item.synonyms}
                  </p>
                )}
              </div>
            );
            })}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default MedicalAlertGlossaryPage;
